interface ElementMessageReaderProps {
  messageSubject: string | null
  messageSender: string | null
  messageReceivedAt: string | null
  messageToAddresses: string | null
  messageBodyContent: string | null
  isMessageBodyLoading: boolean
  onMarkRead: () => void
  onToggleStar: () => void
  onReply: () => void
  onForward: () => void
  onDelete: () => void
}

function extractRawEmailBodyText(rawEmailContent: string): string {
  const bodyStartIndex = rawEmailContent.search(/\r?\n\r?\n/)
  if (bodyStartIndex === -1) return rawEmailContent
  return rawEmailContent.slice(bodyStartIndex).trim()
}

export function ElementMessageReader({
  messageSubject,
  messageSender,
  messageReceivedAt,
  messageToAddresses,
  messageBodyContent,
  isMessageBodyLoading,
  onMarkRead,
  onToggleStar,
  onReply,
  onForward,
  onDelete
}: ElementMessageReaderProps) {
  if (!messageSubject && !messageBodyContent) {
    return (
      <div className="element-reader-empty">
        <span className="element-reader-empty-icon">◈</span>
        <p className="element-reader-empty-label">Select a message to read</p>
      </div>
    )
  }

  const formattedReceivedDate = messageReceivedAt
    ? new Date(messageReceivedAt).toLocaleString()
    : ''

  const displayableBodyContent = messageBodyContent
    ? extractRawEmailBodyText(messageBodyContent)
    : ''

  return (
    <div className="element-message-reader">
      <div className="element-reader-toolbar">
        <button className="element-toolbar-button" onClick={onMarkRead}>
          Mark read
        </button>
        <button className="element-toolbar-button" onClick={onToggleStar}>
          ★ Star
        </button>
        <button className="element-toolbar-button" onClick={onReply}>
          Reply
        </button>
        <button className="element-toolbar-button" onClick={onForward}>
          Forward
        </button>
        <button
          className="element-toolbar-button element-toolbar-button--danger"
          onClick={onDelete}
        >
          Delete
        </button>
      </div>

      <div className="element-reader-body">
        <h1 className="element-reader-subject">
          {messageSubject || '(no subject)'}
        </h1>

        <div className="element-reader-metadata">
          <div className="element-reader-meta-row">
            <span className="element-meta-label">From</span>
            <span className="element-meta-value">{messageSender}</span>
          </div>
          {messageToAddresses && (
            <div className="element-reader-meta-row">
              <span className="element-meta-label">To</span>
              <span className="element-meta-value">
                {JSON.parse(messageToAddresses).join(', ')}
              </span>
            </div>
          )}
          <div className="element-reader-meta-row">
            <span className="element-meta-label">Date</span>
            <span className="element-meta-value">{formattedReceivedDate}</span>
          </div>
        </div>

        <div className="element-reader-content">
          {isMessageBodyLoading ? (
            <div className="element-loading-indicator">Loading message body...</div>
          ) : (
            <div
              className="element-reader-body-text"
              dangerouslySetInnerHTML={{ __html: displayableBodyContent }}
            />
          )}
        </div>
      </div>
    </div>
  )
}
